import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Col, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import WidgetDropdownList from 'react-widgets/lib/DropdownList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

class DropdownList extends Component {
	componentDidMount() {
		const { input: { onChange, value }, defaultSelectedId } = this.props;

		if (value) {
			onChange(value);
		} else if (defaultSelectedId) {
			onChange(defaultSelectedId);
		}
	}

	render() {
		const { name, label, horizontal, t, input: { onChange, value }, help, meta: { touched, error, warning }, required, options, clearable, valueField, valueComponent, placeholder, disabled, defaultSelectedId, ...props } = this.props;

		const validationState = touched && (error && "error") || (warning && "warning") || null;

		// react-widgets compares item[valueField] === value with strict equality.
		// redux-form often stores the value as a string (e.g. '110063') while options carry
		// numeric ids — resolve the matching item up-front using a string-coerced compare.
		const resolvedValue = valueField && value != null && options
			? options.find(opt => String(opt[valueField]) === String(value)) || value
			: value;

		const formControl = <WidgetDropdownList
			name={name}
			value={resolvedValue}
			data={options}
			placeholder={placeholder || t('Common_Select')}
			onChange={item => onChange(valueField ? item[valueField] : item)}
			valueField={valueField}
			valueComponent={clearable ? WithClearableSelection(() => onChange(null), valueComponent, disabled) : valueComponent}
			disabled={disabled}
			{...props}	// textField, itemComponent, filter, onSearch
		/>;
		const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
		const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
		const labelHint = required && <em className='required_s'>*</em>;

		if (horizontal) {
			return (
				<FormGroup validationState={validationState}>
					<Col componentClass={ControlLabel} sm={2}>
						{label}{labelHint}
					</Col>
					<Col sm={10}>
						{formControl}
						{errorBlock}
						{helpBlock}
					</Col>
				</FormGroup>);
		}

		return (
			<FormGroup validationState={validationState}>
				<ControlLabel>{label}{labelHint}</ControlLabel>
				{formControl}
				{errorBlock}
				{helpBlock}
			</FormGroup>
		);
	}
}

export const WithClearableSelection = (onClear, valueComponent, disabled) => {
	return ({ item }) => (
		<span>
			{valueComponent({ item })}
			{!disabled && <span onClick={onClear} style={{ float: 'right', cursor: 'pointer' }}><FontAwesomeIcon icon={faXmark} /></span>}
		</span>
	);
};

export default withTranslation()(DropdownList);